import React from 'react';

/**
 * Invisible field that only automated submitters fill in.
 *
 * Hidden with absolute positioning rather than display:none - some bots skip
 * fields that are display:none, and this way it is still not rendered anywhere
 * a person can see or tab to. aria-hidden and tabIndex keep it away from
 * screen readers and keyboard navigation; autoComplete="off" plus an unusual
 * name stop browsers helpfully filling it for a real user.
 *
 * The backend treats any value here as a bot and silently discards the
 * submission. See models/newsletter.py.
 */
export default function Honeypot({ value, onChange }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
      <label htmlFor="orb_hp">Leave this field empty</label>
      <input
        id="orb_hp"
        name="orb_hp"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
